import { Button, Title } from '@getinapp/appetizer';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Dollar } from '@styled-icons/boxicons-regular/Dollar';
import { User } from '@styled-icons/boxicons-regular/User';

import * as S from './styles';
import { useLine } from 'hooks/use-line';
import { getPrice } from 'utils/helpers';
import { useRouter } from 'next/router';

export type RemoteLineStatusOnPaymentProps = {
  status: 'success' | 'error';
  onPressBack: () => void;
};

export const RemoteLineStatusOnPayment = ({
  status,
  onPressBack,
}: RemoteLineStatusOnPaymentProps) => {
  const [counter, setCounter] = useState(10);

  const { t } = useTranslation();
  const router = useRouter();
  const { unit, settings, handleSetUnit, quantity } = useLine();

  useEffect(() => {
    if (status === 'success') {
      counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
      if (counter === 0) {
        handleSetUnit(null);
        router.push('/my-position');
      }
    }
  }, [counter, status, handleSetUnit, router]);

  if (!settings || !unit) return null;

  const informations = {
    success: {
      title: t('@RemoteLineStatusOnPayment.title-success'),
      subtitle: t('@RemoteLineStatusOnPayment.subtitle-success'),
      button: t('@RemoteLineStatusOnPayment.follow-your-position'),
      onPress: () => {
        handleSetUnit(null);
        router.push('/my-position');
      },
    },

    error: {
      title: t('@RemoteLineStatusOnPayment.title-error'),
      subtitle: t('@RemoteLineStatusOnPayment.subtitle-error'),
      button: t('@RemoteLineStatusOnPayment.back'),
      onPress: () => {
        onPressBack();
      },
    },
  };
  return (
    <>
      <S.StatusHeader status={status}>
        <Title>{informations[status].title}</Title>
        <p>{informations[status].subtitle}</p>
      </S.StatusHeader>
      <S.Header>
        <S.Avatar src={unit.profile_image} alt={unit.name} />
        <div>
          <Title>{unit.name}</Title>
          <p>{unit.full_address}</p>
        </div>
      </S.Header>
      <S.Content>
        {!!settings.pricing && (
          <S.Wrapper>
            <small>
              <span>
                <Dollar size={25} />
              </span>
            </small>
            <small>
              <p>{t('@RemoteLineStatusOnPayment.service-tax')}</p>
              <b>{getPrice(settings.pricing / 100)}</b>
            </small>
          </S.Wrapper>
        )}
        <S.Wrapper>
          <small>
            <span>
              <User size={25} />
            </span>
          </small>
          <small>
            <p>{t('@RemoteLineStatusOnPayment.table-for')}</p>
            <b>
              {t('@RemoteLineStatusOnPayment.peoples', {
                quantity: quantity,
              })}
            </b>
          </small>
        </S.Wrapper>
        {status !== 'success' && (
          <Button variant="outline" onClick={informations[status].onPress}>
            {informations[status].button}
          </Button>
        )}

        {status === 'success' && (
          <>
            <br />
            <p>
              Você será redirecionado a tela de acompanhamento de fila em{' '}
              {counter} segundos.
            </p>
          </>
        )}
      </S.Content>
    </>
  );
};
